import React, { useEffect } from "react";
import "./styles.less";
import { Button } from "rsuite";
import TextImageIcon from '@rsuite/icons/TextImage';
import DetailIcon from '@rsuite/icons/Detail';
import TreemapIcon from '@rsuite/icons/Treemap';
import { MailOutlined, ProfileOutlined, TeamOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import ugr from "@/UGRoute";
import { useDispatch, useSelector } from "react-redux";
import { setShouldFetchProducts } from "@/store/dashboardSlice";

const GrowwizoSimpleHomeDashboard = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { productCount, catalogueCount, activeCatalogueCount, quotationCount, buyersCount, fairEnquiriesCount, } = useSelector(state => state.dashboard);
    useEffect(() => {
        dispatch(setShouldFetchProducts(true));
    }, []);
    const tiles = [
        {
            id: "products",
            title: "All Products",
            description:
                "Add new products and edit or delete existing products in your library.",
            actionLabel: "See all products",
            icon: <TextImageIcon />,
            statLabel: "Products",
            statValue: productCount,
            to: `/${ugr}/products`,

        },
        {
            id: "createCatalogue",
            title: "Create Catalogue for a Buyer",
            description:
                "Select products, customize details and create a catalogue in 2 minutes.",
            actionLabel: "Create a catalogue",
            icon: <TreemapIcon />,
            statLabel: "Total Catalogues",
            statValue: catalogueCount,
            to: `/${ugr}/selection`,

        },
        {
            id: "allCatalogues",
            title: "All Catalogues",
            description:
                "View all catalogues you have created – active, draft and archived.",
            actionLabel: "See all catalogues",
            icon: <DetailIcon />,
            statLabel: "Active catalogues",
            statValue: activeCatalogueCount,
            to: `/${ugr}/manageCatalogue`,

        },
        {
            id: "quotations",
            title: "Quotations",
            description:
                "Track buyer quotations, status and follow-ups in one place.",
            actionLabel: "Manage quotations",
            icon: <ProfileOutlined />,
            statLabel: "Open quotations",
            statValue: quotationCount,
            to: `/${ugr}/manageOrdQ`,

        },
        {
            id: "buyers",
            title: "Buyers & Contacts",
            description:
                "Maintain your buyer master, contacts and key account information.",
            actionLabel: "View buyers",
            icon: <TeamOutlined />,
            statLabel: "Total buyers",
            statValue: buyersCount,
            to: `/${ugr}/addbuyer`,

        },
        {
            id: "enquiries",
            title: "Trade Fair Enquiries",
            description:
                "Capture enquiries from fairs and convert them into catalogues or quotes.",
            actionLabel: "Open enquiry tracker",
            icon: <MailOutlined />,
            statLabel: "New this week",
            statValue: fairEnquiriesCount,
            to: `/${ugr}/enqury-tracker`,

        },
    ];

    return (
        <div className="dashboard-container">
            <header className="dashboard-header">
                <h1>Welcome to Growwizo!</h1>
                <span>
                    Manage all your products, build catalogues and share with buyers in minutes. Start with one of the quick options below.
                </span>
            </header>

            <main className="dashboard-main">
                <div className="tiles-grid">
                    {tiles.map((tile) => (
                        <section key={tile.id} className="tile-card">
                            <div className="tile-icon">{tile.icon}</div>

                            <h3>{tile.title}</h3>
                            <p className="description">{tile.description}</p>

                            <p className="stat">
                                <span className="stat-value">{tile.statValue} </span>
                                <span className="stat-label">{tile.statLabel}</span>
                            </p>

                            <Button className="primary-btn" onClick={() => navigate(tile.to || `/${ugr}/dashboard`)}>{tile.actionLabel}</Button>
                        </section>
                    ))}
                </div>
            </main>
        </div>
    );
};

export default GrowwizoSimpleHomeDashboard;
